// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner__loader__UBmsk","load1":"Spinner__load1__3Y-9z"};